module.exports = __webpack_public_path__ + "img/sad-active.b7df2a4f.png";